// logger.ts — centralized error reporting
// Uses bare fetch(), NOT the Axios api instance, to avoid infinite loops
// when the interceptor itself triggers an error.

let _getToken: (() => string | null) | null = null;

export function initLogger(getToken: () => string | null): void {
  _getToken = getToken;
}

export function logError(
  source: string,
  err:    unknown,
  meta?:  Record<string, unknown>,
): void {
  const message = err instanceof Error ? err.message : String(err);
  const stack   = err instanceof Error ? (err.stack ?? undefined) : undefined;
  const token   = _getToken?.() ?? null;

  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  void fetch("/api/logs/client-error", {
    method:  "POST",
    headers,
    body: JSON.stringify({
      source,
      message,
      stack,
      meta:      meta ?? null,
      url:       window.location.href,
      userAgent: navigator.userAgent,
    }),
  }).catch(() => {});
}
